// Vendor Components
import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const RouteContext = React.createContext({
    location: undefined,
    push: undefined,
    routerParams: undefined,
});
